import { setSessionStore, removeSessionStore } from '@/utils/storage'
import { MENUS, PROJECT_EDIT } from '@/store/mutation-types'
const app = {
    namespaced: true,
    state: {
        dict: null,
        screenHeight: null,
        projectIsEdit: false,
    },

    mutations: {
        setDict(state, payload) {
            state.dict = payload.dict;
        },
        setScreenHeight(state, payload) {
            state.screenHeight = payload.dict;
        },
        setProjectIsEdit(state, payload) {
            state.projectIsEdit = payload
            setSessionStore(PROJECT_EDIT, payload)
        }
    },

    actions: {

    }
}

export default app
